import { memo } from 'react';
import namespace from '../namespace';

import ErrorBoundary from '../../components/ErrorBoundary';
import OpenTransactions from './kpi/OpenTransactions';
import CaptureChart from './kpi/CaptureChart';
import { useActions } from '../../Actions';
import { useSelector } from 'react-redux';
import { State } from '../../reducer';
import useEffectCallback from '../../util/useEffectCallback';
import { useAccount } from '../../settings/account/hooks';
import { accountCurrencies } from '../../settings/account/helpers';
import { Account } from '../../types/management-auth';
import { getDefaultCountryCurrency, currencyCodes } from '../../helpers/currency';

const getCurrency = (account: Account | undefined) => {
    const currencies = account ? accountCurrencies(account) : [];
    if (currencies.length > 0) {
        return currencies;
    }
    // noting configured so lets try to use a sane default
    return [getDefaultCountryCurrency(account, [...currencyCodes], 'NOK')];
};

const Insight = () => {
    const { data, loading: isLoadingKpis } = useSelector<State, State[typeof namespace]>(
        (s) => s[namespace]
    );
    const { account, isLoading: isLoadingAccount } = useAccount();

    const currency = getCurrency(account);

    const isLoading = isLoadingKpis || isLoadingAccount;
    const actions = useActions(namespace);
    useEffectCallback(actions.loadInsightKpis, []);
    return (<>
        <ErrorBoundary>{data.dailyOpenKpis && <OpenTransactions loading={isLoading} openKpisCollection={data.dailyOpenKpis} openKpisCreatedAtGte={data.dailyOpenKpisCreatedAtGte} currencies={currency} />}</ErrorBoundary>
        <ErrorBoundary>{data.dailyCapturedKpis && <CaptureChart loading={isLoading} kpisCollection={data.dailyCapturedKpis} currencies={currency} />}</ErrorBoundary>
    </>
    );
};

export default memo(Insight);
